/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteProjectTermsResource
 */
export interface QuoteProjectTermsResource {
    /**
     * 
     * @type {string}
     * @memberof QuoteProjectTermsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteProjectTermsResource
     */
    url: string;
    /**
     * 
     * @type {Date}
     * @memberof QuoteProjectTermsResource
     */
    freelancerAcceptedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteProjectTermsResource
     */
    clientAcceptedAt?: Date;
}

/**
 * Check if a given object implements the QuoteProjectTermsResource interface.
 */
export function instanceOfQuoteProjectTermsResource(value: object): value is QuoteProjectTermsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function QuoteProjectTermsResourceFromJSON(json: any): QuoteProjectTermsResource {
    return QuoteProjectTermsResourceFromJSONTyped(json, false);
}

export function QuoteProjectTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteProjectTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'freelancerAcceptedAt': json['freelancerAcceptedAt'] == null ? undefined : (new Date(json['freelancerAcceptedAt'])),
        'clientAcceptedAt': json['clientAcceptedAt'] == null ? undefined : (new Date(json['clientAcceptedAt'])),
    };
}

export function QuoteProjectTermsResourceToJSON(value?: QuoteProjectTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
        'freelancerAcceptedAt': value['freelancerAcceptedAt'] == null ? undefined : ((value['freelancerAcceptedAt']).toISOString()),
        'clientAcceptedAt': value['clientAcceptedAt'] == null ? undefined : ((value['clientAcceptedAt']).toISOString()),
    };
}

